module.exports = __webpack_public_path__ + "static/img/img_6.0c16b303.jpg";